import React from "react";
import "./FooterDesktop.css";
import * as _ from "lodash";
import { ReactComponent as NexiLogo } from "../../../resources/images/logoNexi.svg";
import { GoogleTagManagerService } from "../../../services/analitycs/GoogleTagManagerService";
import { Route } from "react-router-dom";

export class FooterDesktop extends React.Component<any, any> {
  private static T_AND_C_KEY = "terms_and_condition";

  manageTermsAndConditions(history: any) {
    GoogleTagManagerService.getInstance().pushInteractionEvent("Click", "footer", "click", "termini e condizioni");
    console.log("[Footer][goToTermsAndConditions] go to T&C page!");
    history.push("/termsAndConditions", { fromHome: true });
  }

  render() {
    return (
      <div id={"desktop-footer-body"} className={"footer-body"}>
        <div className={"content"}>
          <div className={"footer-row-1"}>
            <div className={"footer-row-1-container"}>
              <div className={"footer-row-1-logo-container"}>
                <NexiLogo className={"logo-image"} />
              </div>
              <span className={"footer-row-1-separator"} />
              <div className={"footer-row-1-link-container"}>
                <a href={this.props.supportLink}>SUPPORTO</a>
              </div>
            </div>
          </div>
          <div className={"footer-row-2"}>
            <div className={"footer-row-2-container"}>
              <div className={"footer-row-2-main-link-container"}>
                <a href={this.props.mainLink} className={"main-link"}>
                  NEXI.IT
                </a>
              </div>
              <div className={"footer-row-2-menu-container"}>
                <div className={"menu-links-container"}>
                  <div className={"links-content"}>
                    {_.map(this.props.menuItems, (value: object) => {
                      // @ts-ignore
                      let ref: string = value["ref"] as string;
                      // @ts-ignore
                      let label: string = value["label"];
                      // @ts-ignore
                      let key: string = value["key"];

                      let index = _.indexOf(this.props.menuItems, value);
                      let size = _.size(this.props.menuItems);
                      let className = index === 0 ? "first-anchor-container" : index === size - 1 ? "last-anchor-container" : "middle-anchor-container";
                      return (
                        <div key={key} className={className}>
                          {FooterDesktop.T_AND_C_KEY === key ? (
                            <Route
                              render={({ history }) => {
                                return (
                                  <p
                                    className={"paragraph-link-anchor-custom"}
                                    key={key}
                                    onClick={() => {
                                      this.manageTermsAndConditions(history);
                                      return false;
                                    }}>
                                    {label}
                                  </p>
                                );
                              }}
                            />
                          ) : (
                            <a className={"menu-link-anchor"} key={key} href={ref}>
                              {label}
                            </a>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
                <p className={"copyright-text"}>Copyright &copy; 2020 Tutti i diritti riservati.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
